<template>
  <div class="login-card__reset-password-email">
    <div class="login-card__title-box">
      <h1 class="login-card__title">{{ trans.get('auth.card.password_reset.email.header') }}</h1>
      <p class="login-card__title-desc">{{ trans.get('auth.card.password_reset.email.subheader') }}</p>
    </div>
    <div>
      <validation-observer ref="form" v-slot="{ handleSubmit }">
        <div class="row">
          <div class="col-12">
            <validation-provider name="email" v-slot="{ errors }" mode="eager">
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>


        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="form-row">
            <div class="form-group col-12">
              <validation-provider name="password" rules="required|confirmed:password_confirmation" v-slot="{ errors }" mode="eager">
                <label for="password"></label>
                <input type="password" id="password" class="input-text input-text__underline" v-model="form.password" :placeholder="trans.get('auth.card.fields.new_password')">
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-12">
              <validation-provider name="password confirmation" rules="required" v-slot="{ errors }" vid="password_confirmation" mode="eager">
                <label for="password-confirmation"></label>
                <input
                  type="password" id="password-confirmation" class="input-text input-text__underline" v-model="form.password_confirmation"
                  :placeholder="trans.get('auth.card.fields.new_password_confirmation')"
                >
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <button type="submit" class="button button__fill button--w-100 mt-5">{{ trans.get('auth.card.buttons.send') }}</button>
        </form>
      </validation-observer>

      <button type="button" class="button button__link button__link--underline mt-3" @click="swapComponent('auth-reset-password-card')">{{ trans.get('auth.card.buttons.back') }}</button>
    </div>
  </div>
</template>
<script>
export default {
  props: ['swapComponent'],
  data: () => ({
    form: {
      token: '',
      email: '',
      password: '',
      password_confirmation: '',
    },
  }),
  methods: {
    onSubmit() {
      const self = this;
      axios
        .post(zRoute('password.update.email'), this.form)
        .then(function (response) {
          window.location.href = zRoute('front.members.index');
        }, function (error) {
          if (error.response.status === 422) {
            self.$refs.form.setErrors(error.response.data.errors);
          }
        });
    },
    getUrlParameters(index) {
      return window.location.href.split('/')[index];
    }
  },
  mounted() {
    this.form.token = this.getUrlParameters(5);
    this.form.email = this.getUrlParameters(6);
  }
};
</script>
<style scoped>
</style>
